import moment from 'moment';
import { AnalyticalClassificationType, DayType } from 'domain/master/storeManagement/salesBudgetDailyInput';
import ApiClient from './ApiClient';

export interface SalesBudgetYear {}

/**
 * getPayslipCsvFormat
 *
 * @param formatType
 *
 */
export const importFileExceltoBudgetYear = async (
  uploadFile: File,
  orgCode: any,
  targetYear: any,
): Promise<Array<SalesBudgetYear>> => {
  // TODO: companyCode取得処理はどこかでラップしたほうがよいかも
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const staffName = sessionStorage.getItem('loginUser.staffName') || '';
  const params = {
    orgCode,
    targetYear,
    createUser: staffName,
    updateUser: staffName,
  };

  const response = await ApiClient.postFile(
    `/v2/salesBudgetYearly/importExcel/${companyCode}`,
    params,
    'uploadFile',
    uploadFile,
  );
  return response.data;
};

/**
 * getPayslipCsvFormat
 *
 * @param formatType
 *
 */
export const importCSVFileToBudgetYear = async (uploadFile: File): Promise<Array<SalesBudgetYear>> => {
  // TODO: companyCode取得処理はどこかでラップしたほうがよいかも
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const loginUserName = sessionStorage.getItem('loginUser.staffName') || '';
  const params = {
    loginStaffCode,
    updateUser: loginUserName,
  };

  const response = await ApiClient.postFile(
    `/v2/salesBudgetYearly/importCsv/${companyCode}`,
    params,
    'uploadFile',
    uploadFile,
  );
  return response.data;
};

export const importCSVFileToBudgetYearInput = async (uploadFile: File): Promise<Array<SalesBudgetYear>> => {
  // TODO: companyCode取得処理はどこかでラップしたほうがよいかも
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const loginUserName = sessionStorage.getItem('loginUser.staffName') || '';
  const params = {
    loginStaffCode,
    updateUser: loginUserName,
  };

  const response = await ApiClient.postFile(
    `/v2/salesBudgetYearly/input/importCsv/${companyCode}`,
    params,
    'uploadFile',
    uploadFile,
  );
  return response.data;
};

export const importCSVFileToBudgetDailyInput = async (uploadFile: File): Promise<Array<SalesBudgetYear>> => {
  // TODO: companyCode取得処理はどこかでラップしたほうがよいかも
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const loginUserName = sessionStorage.getItem('loginUser.staffName') || '';
  const params = {
    loginStaffCode,
    updateUser: loginUserName,
  };

  const response = await ApiClient.postFile(
    `/v2/salesBudgetPlan/daily/input/importCsv/${companyCode}`,
    params,
    'uploadFile',
    uploadFile,
  );
  return response.data;
};

export const exportFileExceltoBudgetYear = async (
  orgCode: any,
  orgName: any,
  targetYear: any,
  procDateStr: any,
  categoryAry: any,
): Promise<Array<SalesBudgetYear>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any, index: number) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  orgName = `${orgCode} ${orgName}`;
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const params = {
    orgCode,
    orgName,
    targetYear,
    procDateStr,
    loginStaffCode,
    functionType: 3,
  };
  const response = await ApiClient.getDownloadFile(
    `/v3/salesBudgetYearly/outputExcel/${companyCode}?${appendUrl}`,
    params,
  );
  return response.data;
};

export const exportFileExcelToBudgetYear = async (
  orgCode: string,
  orgName: string,
  targetYear: any,
  procDateStr: any,
  categoryAry: any,
): Promise<Array<SalesBudgetYear>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  const customOrgName = `${orgCode} ${orgName}`;
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const params = {
    orgCode,
    orgName: customOrgName,
    targetYear,
    procDateStr,
    loginStaffCode,
    functionType: 3,
  };
  const response = await ApiClient.getDownloadFile(
    `/v3/salesBudgetYearly/outputExcel/${companyCode}?${appendUrl}`,
    params,
  );
  return response.data;
};

export const exportCSVMonthlyFileToBudgetYear = async (params: {
  orgCode: string;
  targetYear: string;
  functionType?: number;
  categoryAry: string[];
}): Promise<Array<SalesBudgetYear>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const response = await ApiClient.getDownloadFile(`/v2/salesBudgetYearly/outputCsv/${companyCode}`, {
    orgCode: params.orgCode,
    targetYear: params.targetYear,
    loginStaffCode,
    functionType: params.functionType || 3,
    categoryAry: params.categoryAry,
  });
  return response.data;
};

export const exportCSVMonthlyFileToBudgetYearInput = async (params: {
  orgCode: string;
  targetYear: string;
  functionType?: number;
  categoryAry: string[];
}): Promise<Array<SalesBudgetYear>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const response = await ApiClient.getDownloadFile(`/v2/salesBudgetYearly/input/outputCsv/${companyCode}`, {
    orgCode: params.orgCode,
    targetYear: params.targetYear,
    loginStaffCode,
    functionType: params.functionType || 3,
    categoryAry: params.categoryAry,
  });
  return response.data;
};

export enum OutputType {
  YEARLY = 0, // 年間
  MONTHLY = 1, // 月間
}

export const exportCSVDailyFile = async (params: {
  outputType: OutputType;
  orgCode: string;
  targetMonth: string;
  functionType?: number;
  categoryAry: string[];
}): Promise<Array<SalesBudgetYear>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';

  const response = await ApiClient.getDownloadFile(`/v2/salesBudgetPlan/daily/outputCsv/${companyCode}`, {
    outputType: params.outputType,
    orgCode: params.orgCode,
    targetMonth: params.targetMonth,
    loginStaffCode,
    functionType: params.functionType || 3,
    categoryAry: params.categoryAry,
  });
  return response.data;
};

export const exportCSVDailyInputFile = async (params: {
  outputType: OutputType;
  orgCode: string;
  targetMonth: string;
  functionType?: number;
  categoryAry: string[];
}): Promise<Array<SalesBudgetYear>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';

  const response = await ApiClient.getDownloadFile(`/v2/salesBudgetPlan/daily/input/outputCsv/${companyCode}`, {
    outputType: params.outputType,
    orgCode: params.orgCode,
    targetMonth: params.targetMonth,
    loginStaffCode,
    functionType: params.functionType || 3,
    categoryAry: params.categoryAry,
  });
  return response.data;
};

export const updateSalesBudgetYear = async (companyCode: string, data: string) => {
  // TODO パラメータ確認
  const response = await ApiClient.postOriginalData(`/v2/salesBudgetYearly/${companyCode}`, {}, data);
  return response.data;
};

export const getFiscalYearFromDate = async () => {
  // TODO パラメータ確認
  const params = {
    date: moment(new Date(), 'YYYY/MM/DD').format('YYYY-MM-DD'),
  };
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const response = await ApiClient.get(`/v1/fiscalYear/targetdate/${companyCode}`, params);
  return response.data;
};

export const getFiscalYearFromDateToYear = async (year: number) => {
  // TODO パラメータ確認
  const params = {
    year,
  };
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';

  const response = await ApiClient.get(`/v1/fiscalYear/targetyear/${companyCode}`, params);
  return response.data;
};

export const getBiasSetting = async (orgCode: any, targetMonth: any) => {
  const query = {
    orgCode,
    targetMonth,
  };
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/salesPlan/daily/biasSetting/${companyCode}`, query, {});
  return response.data;
};

export const salesBudgetPlanDaily = async (orgCode: any, targetMonth: any) => {
  const query = {
    orgCode,
    targetMonth,
  };
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v2/salesBudgetPlan/daily/${companyCode}`, query, {});
  return response.data;
};

export const salesBudgetPlanDailyInput = async (orgCode: any, targetMonth: any) => {
  const query = {
    orgCode,
    targetMonth,
  };
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v2/salesBudgetPlan/daily/input/${companyCode}`, query, {});
  return response.data;
};

export const updateSalesBudgetMonth = async (companyCode: string, data: any) => {
  // TODO パラメータ確認
  const response = await ApiClient.postOriginalData(`/v2/salesBudgetPlan/daily/${companyCode}`, {}, data);
  return response.data;
};

export const updateSalesBudgetDailyInput = async (
  companyCode: string,
  data: {
    orgCode: string;
    targetMonth: string;
    loginStaffCode: string;
    updateUser: string;
    storeHolidayList: string[];
    budgetInputDataList: {
      analyticalItemCode: string;
      analyticalItemId: string;
      advertisingMediaMstCode: string;
      analyticalClassificationType: string;
      budgetType: number;
      totalAmount: number;
      dailyAmountList?: number[];
      dailyDistributionValue?: number;
      dailyDistributionRoundingValue?: number;
      dailyDistributionRoundingDate?: string;
    }[];
    budgetSummaryDataList: {
      analyticalClassificationType: AnalyticalClassificationType;
      totalAmount: number;
      dailyAmountList: number[];
    }[];
  },
) => {
  // TODO パラメータ確認
  const response = await ApiClient.postParams(`/v2/salesBudgetPlan/daily/input/${companyCode}`, data);
  return response.data;
};

export const updateSalesBudgetYearlyInput = async (
  companyCode: string,
  data: {
    orgCode: string;
    targetYear: string;
    loginStaffCode: string;
    updateUser: string;
    budgetInputDataList: {
      analyticalItemCode: string;
      analyticalItemName: string;
      analyticalItemId: string;
      advertisingMediaMstCode: string;
      analyticalClassificationType: string;
      expensesClassification: number;
      budgetType: number;
      sumFlag: number;
      budgetDistributionType: DayType;
      monthlyAmountList: number[];
    }[];
    budgetSummaryDataList: {
      analyticalClassificationType: AnalyticalClassificationType;
      totalAmount: number;
    }[];
  },
) => {
  const response = await ApiClient.postParams(`/v2/salesBudgetYearly/input/${companyCode}`, data);
  return response.data;
};

export type Error = {
  error: string;
  defaultMessage: string;
};

export default {
  importFileExceltoBudgetYear,
  importCSVFileToBudgetYear,
  importCSVFileToBudgetYearInput,
  importCSVFileToBudgetDailyInput,
};
